/**
 * Tooltip Help Component
 *
 * Reusable component for adding inline help tooltips to technical terms.
 */

import { HelpOutlined as HelpIcon } from '@mui/icons-material';
import { Box, Tooltip, Typography } from '@mui/material';

interface TooltipHelpProps {
  term: string;
  explanation: string;
  /** Optional: render as inline span instead of box */
  inline?: boolean;
}

export function TooltipHelp({ term, explanation, inline = false }: TooltipHelpProps) {
  const content = (
    <>
      <Typography component="span">{term}</Typography>
      <Tooltip title={explanation} arrow placement="top">
        <HelpIcon
          sx={{
            fontSize: 16,
            ml: 0.5,
            color: 'text.secondary',
            cursor: 'help',
            verticalAlign: 'middle',
          }}
        />
      </Tooltip>
    </>
  );

  if (inline) {
    return <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>{content}</Box>;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {content}
    </Box>
  );
}
